import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IRejectionReasonDriver, defaultValue } from 'app/shared/model/rejection-reason-driver.model';

export const ACTION_TYPES = {
  FETCH_REJECTIONREASONDRIVER_LIST: 'rejectionReasonDriver/FETCH_REJECTIONREASONDRIVER_LIST',
  FETCH_REJECTIONREASONDRIVER: 'rejectionReasonDriver/FETCH_REJECTIONREASONDRIVER',
  CREATE_REJECTIONREASONDRIVER: 'rejectionReasonDriver/CREATE_REJECTIONREASONDRIVER',
  UPDATE_REJECTIONREASONDRIVER: 'rejectionReasonDriver/UPDATE_REJECTIONREASONDRIVER',
  DELETE_REJECTIONREASONDRIVER: 'rejectionReasonDriver/DELETE_REJECTIONREASONDRIVER',
  RESET: 'rejectionReasonDriver/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IRejectionReasonDriver>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type RejectionReasonDriverState = Readonly<typeof initialState>;

// Reducer

export default (state: RejectionReasonDriverState = initialState, action): RejectionReasonDriverState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REJECTIONREASONDRIVER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_REJECTIONREASONDRIVER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_REJECTIONREASONDRIVER):
    case REQUEST(ACTION_TYPES.UPDATE_REJECTIONREASONDRIVER):
    case REQUEST(ACTION_TYPES.DELETE_REJECTIONREASONDRIVER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_REJECTIONREASONDRIVER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_REJECTIONREASONDRIVER):
    case FAILURE(ACTION_TYPES.CREATE_REJECTIONREASONDRIVER):
    case FAILURE(ACTION_TYPES.UPDATE_REJECTIONREASONDRIVER):
    case FAILURE(ACTION_TYPES.DELETE_REJECTIONREASONDRIVER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_REJECTIONREASONDRIVER_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_REJECTIONREASONDRIVER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_REJECTIONREASONDRIVER):
    case SUCCESS(ACTION_TYPES.UPDATE_REJECTIONREASONDRIVER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_REJECTIONREASONDRIVER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/rejection-reason-driver-reports';

// Actions

export const getEntities: ICrudGetAllAction<IRejectionReasonDriver> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_REJECTIONREASONDRIVER_LIST,
  payload: axios.get<IRejectionReasonDriver>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IRejectionReasonDriver> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_REJECTIONREASONDRIVER,
    payload: axios.get<IRejectionReasonDriver>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IRejectionReasonDriver> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_REJECTIONREASONDRIVER,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IRejectionReasonDriver> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_REJECTIONREASONDRIVER,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IRejectionReasonDriver> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_REJECTIONREASONDRIVER,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
